<template>
  <Checkbox :id="`transact-sso-checkbox`" v-model="checkboxValue" :disabled="!editMealPlan" binary>
    <template #label> {{ translate(`${LOCALE_PREFIX}.form.transactSSOCheckboxLable`) }}</template>
  </Checkbox>
</template>
<script setup lang="ts">
import { Checkbox } from '@centric-os/components/src/core/controls/checkbox';
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../../routes';

const props = defineProps<{
  institutionId?: string | undefined;
}>();

const emit = defineEmits<{
  'update:checked': [value: boolean];
}>();

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

// Initialize checkbox value based on institutionId
const checkboxValue = ref<boolean>(Boolean(props.institutionId));

// Sync checkbox with institutionId when it changes (e.g., when form data loads asynchronously)
watch(
  () => props.institutionId,
  (newInstitutionId) => {
    if (newInstitutionId && !checkboxValue.value) {
      checkboxValue.value = true;
    }
  },
);

watch(checkboxValue, (newValue) => {
  emit('update:checked', Boolean(newValue));
});
</script>
